module.exports = __webpack_public_path__ + "img/Yipi_AnimacionWeb_08_Celular.77d53ff5.gif";